import * as React from 'react'

export type TitleProps = {
  children: React.ReactNode
}

export const Title = ({ children }: TitleProps) => (
  <h3 className="font-bold text-gray-900 mb-1 text-lg">{children}</h3>
)
